import {
  Box, Text, Select, IcoMoon,
} from '@usap/uicomponents'
import styled from 'styled-components'

export const OrderHistoryBox = styled(Box)`
  padding: 16px;
  margin: 0px auto;
  width: 1000px;

  @media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    padding: 16px;
  }
`
export const RedTextMessage = styled(Text)`
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 20px;
  color: rgb(255, 64, 64);
  margin: 8px 0px;
`
export const OrderListBox = styled(Box)`
`

export const OrderOptionBox = styled(Box)`
  padding-top: 8px;
  padding-bottom: 8px;
  flex-direction: row;
  display: flex;

  @media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    padding-top: 6px;
    padding-bottom: 6px;
  }
`
export const SelectBox = styled(Box)`
  border-radius: 4px;
  width: 155px;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;

  @media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    border-radius: 3px;
  }
`
export const LabelText = styled(Text)`
  align-self: center;
  font-size: 14px;
  line-height: 20px;
`
export const SpacerBox = styled(Box)`
  flex: 0 0 auto;
  align-self: stretch;
  width: 8px;

  @media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    width: 6px;
  }
`
export const IconMoon = styled(IcoMoon)`
  display: inline-block;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  fill: #666666;
`
export const SelectOptions = styled(Select)`
  font-weight: normal;
  padding: 11px;
  background: transparent;
  border-radius: 4px;
  margin: 0;
  line-height: 20px;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: inherit;
  width: 100%;
`
